if (!window.Turbo) {
    window.Turbo = require('@hotwired/turbo');
    window.Turbo.start();

    let headers = {};
    let instigators = {};

    document.addEventListener('turbo:click', async (event) => {
        headers = JSON.parse(event.target.dataset.turboHeaders || '[]');
        instigators[event.detail.url] = event.target;
    });

    document.addEventListener('turbo:before-fetch-request', async (event) => {
        event.detail.fetchOptions.headers = { 'x-turbo-request': '1', ...headers, ...event.detail.fetchOptions.headers };
        headers = {};
    });

    document.addEventListener('turbo:before-fetch-response', async (event) => {
        const response = event.detail.fetchResponse.response;
        const status = response.status;
        const isModalResponse = response.headers.get('x-turbo-modal');
        const instigator = instigators[response.url];
        delete instigators[response.url];

        if (status === 200 && isModalResponse && response.headers.get('Content-Type').includes('text/html')) {
            event.preventDefault();
            document.documentElement.removeAttribute('aria-busy');

            event.detail.fetchResponse.response.text().catch((error) => {
                console.error(error);
                application.toastGeneralError();
            }).then(body => {
                application.createModalOfContent(body, instigator);
            });
        }

        if (status === 403 && response.headers.get('Content-Type') === 'application/json') {
            event.preventDefault();
            document.documentElement.removeAttribute('aria-busy');

            event.detail.fetchResponse.response.json().catch((error) => {
                console.error(error);
                application.toastGeneralError();
            }).then(body => {
                if (body.dashboard_toast) {
                    application.toastMessage(
                        body.dashboard_toast.dashboard_toast_header,
                        body.dashboard_toast.dashboard_toast_description,
                        body.dashboard_toast.dashboard_toast_timeout,
                    );
                }
            });
        }
    });
}
